module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('v-navigation-drawer'), _vm._v(" "), _c('v-toolbar', [_c('v-toolbar-title', [_vm._v("Harmap")])], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs10": "",
      "hidden-md-and-up": ""
    }
  }, [(_vm.localTuning) ? _c('v-select', {
    attrs: {
      "items": _vm.catalogue,
      "item-text": "name"
    },
    model: {
      value: (_vm.localTuning),
      callback: function($$v) {
        _vm.localTuning = $$v
      },
      expression: "localTuning"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "hidden-md-and-up": ""
    }
  }, [(_vm.localKey) ? _c('v-select', {
    attrs: {
      "items": _vm.possibleKeys,
      "item-text": "short",
      "item-value": "pitch"
    },
    model: {
      value: (_vm.localKey),
      callback: function($$v) {
        _vm.localKey = $$v
      },
      expression: "localKey"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.catalogue), function(tuning) {
    return _c('v-list-item', {
      key: tuning,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.localTuning = tuning
        }
      }
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [(_vm.localTuning === tuning) ? _c('v-icon', {
      staticClass: "pink--text"
    }, [_vm._v("star")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(tuning.name)
      }
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-list', {
    staticClass: "localKey",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.possibleKeys), function(k) {
    return _c('v-list-item', {
      key: k.pitch,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.localKey = k.pitch
        }
      }
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [(_vm.localKey === k.pitch) ? _c('v-icon', {
      staticClass: "pink--text"
    }, [_vm._v("star")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(k.short)
      }
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md10": "",
      "xs12": ""
    }
  }, [_c('harmap-grid', {
    attrs: {
      "pattern": _vm.localTuning,
      "harp-key": _vm.selectedKey
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.comment)
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4402fd78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 98
// module chunks = 1